import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={32}
    height={32}
    data-name="Livello 2"
    {...props}
  >
    <defs>
      <style>
        {
          ".cls-178{fill:none;stroke:#a3d8e7;stroke-miterlimit:10;stroke-width:2px}"
        }
      </style>
    </defs>
    <g id="Palette">
      <path
        d="M1 12V1h11M20 1h11v11M1 20v11h11M24 32V16M16 24h16"
        className="cls-178"
      />
    </g>
  </svg>
)
export default SvgComponent
